// extracted by mini-css-extract-plugin
module.exports = {"historyTableWrapper":"TrancheHistoryModal_historyTableWrapper__2qif5","emptyState":"TrancheHistoryModal_emptyState__29S1R"};